import axios from 'axios';
import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Modal } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { BACKEND_SERVER_URL } from '../../../http/http-config';

const CUET_CourseRecommendationModal = forwardRef((props, ref) => {
    const [modalBox, setModalBox] = useState(false);
    const initialData = {
        Title: '',
        Link: '',
        MinPercentage: 0,
        MaxPercentage: 100,
    };
    const [formData, setFormData] = useState(initialData);

    useImperativeHandle(ref, () => ({
        openModal(item = {}) {
            if (item.Sn > 0) {
                setFormData({
                    Sn: item.Sn,
                    Title: item.Title || '',
                    Link: item.Link || '',
                    MinPercentage: item.MinPercentage ?? 0,
                    MaxPercentage: item.MaxPercentage ?? 100,
                });
            } else {
                setFormData(initialData);
            }
            setModalBox(true);
        }
    }));

    const handleSave = async () => {
        try {
            if (!formData.Title?.trim()) {
                toast.error("Please enter a title");
                return;
            }
            if (!formData.Link?.trim()) {
                toast.error("Please enter a link");
                return;
            }
            if (Number(formData.MinPercentage) > Number(formData.MaxPercentage)) {
                toast.error("Min % cannot be greater than Max %");
                return;
            }

            const url = formData.Sn
                ? '/cuet/updateCourseRecommendation'
                : '/cuet/createCourseRecommendation';

            const response = await axios.post(BACKEND_SERVER_URL + url, formData);
            toast.success(response?.data?.message || 'Saved successfully');
        } catch (error) {
            console.log(error);
            toast.error(error?.response?.data?.message || 'Error saving data');
        } finally {
            props.setLoadData(!props.loadData);
            setFormData(initialData);
            setModalBox(false);
        }
    };

    return (
        <Modal onHide={setModalBox} show={modalBox} size="md" backdrop="static" keyboard={false}>
            <div className="modal-content">
                <div className="modal-header">
                    <h5 className="modal-title">{formData.Sn ? "Update" : "Add"} Course Recommendation</h5>
                    <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                </div>
                <div className="modal-body">
                    <div className="mb-3">
                        <label className="form-label text-primary">Title <span className="required">*</span></label>
                        <input
                            autoFocus
                            className='form-control'
                            type="text"
                            placeholder="e.g. Foundation Strengthening Course"
                            value={formData.Title}
                            onChange={(e) => setFormData({ ...formData, Title: e.target.value })}
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label text-primary">Link (URL) <span className="required">*</span></label>
                        <input
                            className='form-control'
                            type="text"
                            placeholder="https://example.com/course"
                            value={formData.Link}
                            onChange={(e) => setFormData({ ...formData, Link: e.target.value })}
                        />
                    </div>
                    <div className="row">
                        <div className="col-6 mb-3">
                            <label className="form-label text-primary">Min Percentage</label>
                            <input
                                className='form-control'
                                type="number"
                                min="0"
                                max="100"
                                value={formData.MinPercentage}
                                onChange={(e) => setFormData({ ...formData, MinPercentage: Number(e.target.value) })}
                            />
                        </div>
                        <div className="col-6 mb-3">
                            <label className="form-label text-primary">Max Percentage</label>
                            <input
                                className='form-control'
                                type="number"
                                min="0"
                                max="100"
                                value={formData.MaxPercentage}
                                onChange={(e) => setFormData({ ...formData, MaxPercentage: Number(e.target.value) })}
                            />
                        </div>
                    </div>
                    <p className="text-muted" style={{ fontSize: '12px' }}>
                        Students scoring between {formData.MinPercentage}% and {formData.MaxPercentage}% will see this recommendation.
                    </p>
                </div>
                <div className="modal-footer">
                    <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                    <button type="button" className="btn btn-primary btn-xs" onClick={handleSave}>
                        {formData.Sn ? "Update" : "Save"}
                    </button>
                </div>
            </div>
        </Modal>
    );
});

export default CUET_CourseRecommendationModal;
